module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"watch":"Посмотреть демо","stop":"Остановить демо","canAsk":"Озвучено вопросов","from":"из","ai":"ИИ","dictor":"Диктор","aiAvatar":"ИИ Аватар","voicingAnyQ":"Озвучка любых вопросов","maxQuestios":"Максимальное кол-во вопросов"}}')
  delete Component.options._Ctor
}
